// extracted by mini-css-extract-plugin
module.exports = {"block":"HeaderBlock_style_block__3AnZO","header":"HeaderBlock_style_header__pfjTc","title":"HeaderBlock_style_title__BVM29","content":"HeaderBlock_style_content__2PfE7"};